module.exports = __webpack_public_path__ + "img/0xc14b601252aa5dfa6166cf35fe5ccd2e35f3fdf5.5df836db.png";